var React = require('react');

function Research (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0, 0)"},[React.createElement("path",{"d":"M15,4h-1C6.28,4,0,10.28,0,18s6.28,14,14,14s14-6.28,14-14v-1H15V4z","key":0}),React.createElement("path",{"data-color":"color-2","d":"M18,0h-1v15h15v-1C32,6.28,25.72,0,18,0z","key":1})]));
}

Research.defaultProps = {"x":"0px","y":"0px","width":"32px","height":"32px","viewBox":"0 0 32 32"};

module.exports = Research;

Research.default = Research;
